import React from 'react';
import styled from 'styled-components';

import Fade from 'react-reveal/Fade';

const Container = styled.section`
  p {
    color: ${(props) => props.theme.textColorLite} !important;
  }
  .columns.is-vcentered {
    flex-direction: ${(props) => (props.flex ? 'row-reverse' : '')};
  }
`;

const CultureInfo = ({ title, subtitle, image, flex }) => {
  return (
    <Container className="section" flex={flex}>
      <div className="container">
        <div className="columns is-vcentered">
          <div className="column is-5">
            <Fade left big cascade>
              <h1 className="title is-3 has-text-centered">{title}</h1>
              <p className="has-text-centered">{subtitle}</p>
            </Fade>
          </div>
          <div className="column is-7">
            <Fade right big cascade>
              <figure className="image is-3by2">
                <img src={image} alt="offers" />
              </figure>
            </Fade>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CultureInfo;
